import { useLayoutEffect, useState, useRef } from 'react';
import { useTheme } from 'styled-components';
import {
  DropdownOptions,
  Flex,
  ModalProvider,
  PaginationProvider,
  SearchProvider,
  TooltipPopup,
} from 'dash-ui';

import AmenitiesList from './components/AmenitiesList/AmenitiesList';
import AmenitiesTopBar from './components/AmenitiesTopBar/AmenitiesTopBar';
import SaveAmenityModal from './components/SaveAmenityModal/SaveAmenityModal';
import { SaveAmenityModalData } from './components/SaveAmenityModal/SaveAmenityModal.interfaces';
import DeleteAmenityModal from './components/DeleteAmenityModal/DeleteAmenityModal';

const PER_PAGE = 12;
const listItemSizes = {
  minWidth: 260,
  gap: 24,
};

const AmenitiesPage = () => {
  const theme = useTheme();
  const listRef = useRef(null);
  const [amenitySaveModal, setAmenitySaveModal] =
    useState<SaveAmenityModalData>(null);
  const setSaveModal = (doc: SaveAmenityModalData) => setAmenitySaveModal(doc);
  const [defaultPerPage, setDefaultPerPage] = useState(PER_PAGE);

  useLayoutEffect(() => {
    // calculate count of items base on list width
    const newPerPage = listRef.current
      ? Math.trunc(
          // @ts-ignore
          (listRef.current.clientWidth - theme.space * 6 * 2) /
            (listItemSizes.minWidth + listItemSizes.gap)
        ) * 3
      : 0;
    setDefaultPerPage(Math.max(newPerPage, PER_PAGE));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme]);

  return (
    <>
      <DropdownOptions />
      <TooltipPopup />
      <SaveAmenityModal
        modalData={amenitySaveModal}
        onClose={() => setAmenitySaveModal(null)}
      />
      <PaginationProvider perPage={defaultPerPage}>
        <SearchProvider>
          <ModalProvider>
            <>
              <DeleteAmenityModal />
              <Flex ref={listRef} flex={1} w="100%" flexDirection="column">
                <AmenitiesTopBar
                  defaultPerPage={defaultPerPage}
                  setAmenitySaveModal={setSaveModal}
                />
                <AmenitiesList
                  setAmenitySaveModal={setSaveModal}
                  listItemSizes={listItemSizes}
                />
              </Flex>
            </>
          </ModalProvider>
        </SearchProvider>
      </PaginationProvider>
    </>
  );
};

export default AmenitiesPage;
